module.exports = __webpack_public_path__ + "img/video.a5a03576.gif";